import { Skeleton } from "@mui/material";
import classNames from "classnames";
import { StatChipSkeletonRow } from "./parts";
import styles from "./style.module.scss";

interface AnalyticsHeaderSkeletonProps {
  statCount?: number;
  className?: string;
}

/** Same two-row footprint as the real header so the title never shifts. */
function AnalyticsHeaderSkeleton({
  statCount = 3,
  className,
}: AnalyticsHeaderSkeletonProps) {
  return (
    <div className={classNames(styles.header, className)}>
      <div className={styles.titleWrap}>
        <Skeleton variant="text" width={170} height={32} />
        <StatChipSkeletonRow count={statCount} />
      </div>
    </div>
  );
}

export default AnalyticsHeaderSkeleton;
